module.exports = __webpack_public_path__ + "static/picTile2-aa5c6449c0aa88bba29de17e9f5d32ea.jpg";